const gameCampaignStatusEnum = Object.freeze({
  live: 'Gamification_CampaignList_Status_Live',
  draft: 'Gamification_CampaignList_Status_Draft'
})

export { gameCampaignStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameCampaignStatusEnum.js